import { useContext } from 'react';

import { SidebarContext } from './sidebar-provider';

function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within SidebarContext');
  }

  return context;
}

export { useSidebar };
